import React from "react";
import { Text, Icon } from "@shopify/polaris";
import { DeleteIcon } from "@shopify/polaris-icons";
import { countryDisplay } from "../../settings/countryLanguageOptions";

export default function SelectedCountryList({ codes = [], onRemove, emptyLabel }) {
  if (!codes.length) {
    return (
      <Text as="p" variant="bodySm" tone="subdued">
        {emptyLabel}
      </Text>
    );
  }

  return (
    <div className="fsb-placement-resource-scroll">
      <div className="fsb-placement-resource-rows">
        {codes.map((code) => {
          const { flag, name } = countryDisplay(code);
          return (
            <div key={code} className="fsb-placement-country-row">
              <span className="fsb-placement-country-row__flag" aria-hidden>
                {flag || code}
              </span>
              <span className="fsb-placement-country-row__title" title={name}>
                {name}
              </span>
              <button
                type="button"
                className="fsb-placement-resource-row__delete"
                aria-label={`Remove ${name}`}
                onClick={() => onRemove(code)}
              >
                <Icon source={DeleteIcon} tone="critical" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
